import clsx from 'clsx';
import React, { forwardRef } from 'react';
import './VisuallyHidden.css';
export const VisuallyHidden = forwardRef(function VisuallyHidden(props, ref) {
    const { children, elementType: Element = 'span', className, ...rest } = props;
    return (React.createElement(Element, { ...rest, className: clsx('mollie-ui-visually-hidden', className), ref: ref }, children));
});
VisuallyHidden.displayName = 'VisuallyHidden';
//# sourceMappingURL=VisuallyHidden.js.map